import { useState } from 'react'

import { Flex } from 'antd'
import { ConfirmationModal, Header } from 'govwell-ui'

import { useBlocker } from '@redwoodjs/router'

import SaveChangesButton from 'src/components/UnsavedChangesProtector/SaveChangesButton'
import { UseDisclosureReturn } from 'src/hooks/use-disclosure'

import { useUnsavedChangesBlocker } from '../../hooks/use-unsaved-changes-blocker'

type Props = {
  blocker?: ReturnType<typeof useBlocker>
  children: React.ReactNode
  confirmationModalState?: UseDisclosureReturn
  errorMessage?: string
  hasUnsavedChanges: boolean
  isInvalid?: boolean
  onDiscardChanges?: () => void
  onKeepEditing?: () => void
  onSave: () => Promise<unknown>
  title?: React.ReactNode
}
const UnsavedChangesProtector = ({
  blocker: controlledBlocker,
  children,
  confirmationModalState: controlledConfirmationModalState,
  errorMessage,
  hasUnsavedChanges,
  onDiscardChanges,
  onKeepEditing,
  onSave,
  title,
}: Props) => {
  const { confirmationModalState, handleDiscardChangesClicked, handleKeepEditingClicked } =
    useUnsavedChangesBlocker({
      blocker: controlledBlocker,
      confirmationModalState: controlledConfirmationModalState,
      hasUnsavedChanges,
      onDiscardChanges,
      onKeepEditing,
    })

  const [isLoading, setIsLoading] = useState(false)

  return (
    <Flex vertical style={{ isolation: 'isolate', width: '100%' }} gap="12px">
      {title && <Header title={title} />}
      {children}
      <div
        style={{
          position: 'sticky',
          bottom: 0,
          zIndex: 1,
          backgroundColor: 'white',
          padding: '12px 0px',
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        <SaveChangesButton
          errorMessage={errorMessage}
          hasUnsavedChanges={hasUnsavedChanges}
          isLoading={isLoading}
          onSave={onSave}
          setIsLoading={setIsLoading}
        />
      </div>
      {confirmationModalState.isOpen && (
        <ConfirmationModal
          title="Discard Changes"
          cancelText="Keep editing"
          confirmText="Discard changes"
          isDestructive
          onCancel={handleKeepEditingClicked}
          onConfirm={handleDiscardChangesClicked}
        >
          You have unsaved changes. Are you sure you want to leave the page and discard those
          changes?
        </ConfirmationModal>
      )}
    </Flex>
  )
}

export default React.memo(UnsavedChangesProtector)
